import { render } from "./GridComponent.vue?vue&type=template&id=2b071795"
import script from "./GridComponent.vue?vue&type=script&lang=js"
export * from "./GridComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__